import { appRoles } from 'services/Auth/appRoles';
import { newGuidNil } from 'utils/guid';

//
// A role of the organization. Phase 1 has the system roles only (systemRoleId set), one row per role per
// organization, created with the organization.
//
export class Role {
  roleId: string;

  systemRoleId?: appRoles;

  name: string;

  description?: string;

  constructor() {
    this.roleId = newGuidNil();
    this.name = '';
  }

  static getEmptyRole(id?: string) {
    const newRole = new Role();
    if (id) newRole.roleId = id;

    return newRole;
  }

  clone(): Role {
    const output = new Role();
    output.roleId = this.roleId;
    output.systemRoleId = this.systemRoleId;
    output.name = this.name;
    output.description = this.description;

    return output;
  }

  isEqual(item: Role): boolean {
    return (
      item.roleId === this.roleId &&
      item.systemRoleId === this.systemRoleId &&
      item.name === this.name &&
      item.description === this.description
    );
  }
}
